export default __webpack_public_path__ + "static/media/bellSVG.c92f3597.svg";